import formatCapitalize from './formatCapitalize'

interface FirstLastName {
    firstName?: string | null
    lastName?: string | null
}

const formatName = (user: FirstLastName | undefined | null): string => {
    if (!user) {
        return ''
    }

    const { firstName, lastName } = user

    if (!firstName && !lastName) {
        return ''
    }

    return `${formatCapitalize(firstName)}${firstName && lastName ? ' ' : ''}${formatCapitalize(lastName)}`
}

export default formatName
